import { useCallback } from "react";

import { Ban, X } from "lucide-react";

import { Button } from "@components/button/button";
import { SpinnerSimple } from "@components/spinner-simple/spinner-simple";

import { useInativarModelo } from "@/hooks/modelos/inativar-modelo";

import { useStoreZustandModelos } from "@/store-zustand/modelos/modelos";

type IModalInativarModelo = {
  onCancel: () => void;
};

export function ModalInativarModelo({ onCancel }: IModalInativarModelo) {
  const { modeloUnico } = useStoreZustandModelos();

  const { inativarModeloAsync, isLoading } = useInativarModelo();

  const handleInativarModelo = useCallback(async () => {
    try {
      await inativarModeloAsync(modeloUnico?.id);
    } catch {
      // feedback de erro já exibido pelo hook (onError)
      return;
    }

    onCancel();
  }, [modeloUnico, onCancel, inativarModeloAsync]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="relative w-full max-w-md space-y-5 rounded-lg bg-white p-6 shadow-lg">
        <div className="flex justify-between">
          <h3 className="flex text-left text-lg font-semibold text-gray-800">
            <Ban className="mr-2" /> Confirmar inativação?
          </h3>

          {/* Botão de fechar no topo direito */}
          <button
            onClick={onCancel}
            className="absolute right-3 text-gray-500 hover:text-gray-800"
            aria-label="Fechar modal"
          >
            <X size={20} />
          </button>
        </div>
        <p className="text-left text-sm text-gray-600">
          Você tem certeza de que deseja inativar o modelo{" "}
          <strong className="text-orange-500">{modeloUnico?.nome_modelo}</strong>
          ?<br />
          Ele deixará de ser exibido para o cliente e não poderá receber novas remessas. O histórico
          de remessas já realizadas será mantido e o modelo pode ser reativado a qualquer momento.
        </p>

        <div className="mt-4 flex w-full justify-between gap-4">
          <Button
            disabled={isLoading}
            variant="secondary"
            className="w-full rounded-md bg-gray-200 px-4 py-2 text-gray-700 hover:bg-gray-300"
            onClick={onCancel}
          >
            Cancelar
          </Button>
          <Button
            disabled={isLoading}
            variant="default"
            className="w-full bg-primary px-4 py-2 text-primary-foreground text-white hover:bg-primary/90"
            onClick={handleInativarModelo}
          >
            {isLoading ? <SpinnerSimple /> : "Inativar modelo"}
          </Button>
        </div>
      </div>
    </div>
  );
}
